module.exports = __webpack_public_path__ + "img/enterprise.0d991540.png";